<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">
        {{ $t("inviteParticipantsHeader") }}
      </p>
    </header>
    <section class="modal-card-body">
      <b-message type="is-primary">
        {{ $t("invitedParticipantsExplained") }}
      </b-message>
      <div v-for="(p, key) in invitedParticipants" :key="key">
        <b-field class="my-2" grouped>
          <b-input v-model="p.mail" type="email" :placeholder="$t('email')" class="always-mobile" />
          <!--
          <LanguagePicker
            v-model="p.lang"
            :whitelist="['deu','eng','fra','spa','por','nld','tur','ita']"
          />-->
          <b-button type="is-danger ml-2" icon-left="delete" @click="removeParticipant(key)" />
        </b-field>
      </div>
      <b-button type="is-primary" icon-left="plus" @click="addParticipant">
        {{ $t("addParticipant") }}
      </b-button>
    </section>
    <footer class="modal-card-foot">
      <b-button :loading="isLoading" :disabled="isLoading" @click="$parent.close()">
        {{ $t("close") }}
      </b-button>
      <b-button type="is-primary" :loading="isLoading" :disabled="isLoading" @click="invite">
        {{ $t("invite") }}
      </b-button>
    </footer>
  </div>
</template>

<script>
import { db, functions } from "@/firebase";
//import LanguagePicker from './LanguagePicker'
export default {
  name: "InvitedParticipantsModal",
  components: {
    //LanguagePicker
  },
  props: {
    eventId: {
      type: String,
      required: true,
    },
    organizationId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      invitedParticipants: [],
      isLoading: false,
    };
  },
  computed: {
    newinvitedParticipants() {
      return this.invitedParticipants
        .filter((p) => p.new == true && p.mail && p.mail != "")
        .map((p) => ({ mail: p.mail, lang: p.lang }));
    },
  },
  watch: {
    invitedParticipants: {
      deep: true,
      handler() {
        this.invitedParticipants.forEach((p, i) => {
          let splitted = p.mail.split(/,|;/g);
          if (splitted.length > 1) {
            for (let k = 1; k < splitted.length; k++) {
              this.invitedParticipants.push({
                mail: splitted[k].trim(),
                lang: "",
                new: true,
              });
            }
            this.invitedParticipants[i].mail = splitted[0].trim();
          }
        });
      },
    },
  },
  async mounted() {
    this.invitedParticipants =
      (await db.collection("organizations").doc(this.organizationId).collection("events").doc(this.eventId).get())
        .data()
        .invitedParticipants.map((p) => ({ ...p, new: false })) || [];
  },
  methods: {
    addParticipant() {
      this.invitedParticipants.push({ mail: "", lang: "", new: true });
    },
    removeParticipant(key) {
      this.invitedParticipants.splice(key, 1);
    },
    async invite() {
      this.isLoading = true;
      await db
        .collection("organizations")
        .doc(this.organizationId)
        .collection("events")
        .doc(this.eventId)
        .set(
          {
            invitedParticipants: this.invitedParticipants.map((p) => ({
              mail: p.mail,
              lang: p.lang,
            })),
          },
          { merge: true },
        );
      await functions.httpsCallable("InviteMailParticipant")({
        eventId: this.eventId,
        organizationId: this.organizationId,
        newinvitedParticipants: this.newinvitedParticipants,
      });
      this.isLoading = false;
      this.$parent.close();
      //this.$router.push({name: 'Dashboard', params: {organizationId: this.$store.getters.getOrganizationId}})
    },
  },
};
</script>
